import { FC, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { toggleActivatedEvent } from 'src/Helpers/TagManager'
import { PublicRoutesEnum } from 'src/Router/PublicComponentsNewUI'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'
import { HelmetTitle } from '../../Components/HelmetTitle'
import { CreateCampaignBreadcrumbsNoAuth } from '../../Components/CreateCampaignBreadcrumbsNoAuth'
import { SearchArtistSection } from '../../Components/SearchArtistSection'
import { useSpotifyArtistSearch } from '../../Components/SearchArtistSection/useSpotifyArtistSearch'
import { PreReleaseSignUpState } from '../preReleaseSignUpState'

const FIRST_CAMPAIGN_NUMBER = 1

const Container = styled.div`
  display: flex;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const PreReleaseTrackDetailsNoAuth: FC = () => {
  const navigate = useNavigate()
  const { search } = useCustomSearchParams()
  const artistSearch = useSpotifyArtistSearch()
  const { selectedArtist, trackName } = artistSearch

  useEffect(() => {
    toggleActivatedEvent({
      platformName: CampaignPlatformTypeEnum.SPOTIFY,
      campaignType: CampaignTypeEnum.FIRST,
      campaignNumber: FIRST_CAMPAIGN_NUMBER,
    })
  }, [])

  const onCreateCampaign = (): void => {
    if (!selectedArtist) {
      return
    }

    const state: PreReleaseSignUpState = {
      artist: selectedArtist,
      trackName: trackName.trim(),
    }

    navigate(
      `${PublicRoutesEnum.CreatePreReleaseTrackDetails}${PublicRoutesEnum.SignUpArtist}?${search.toString()}`,
      { state },
    )
  }

  return (
    <NoAuthPageLayout>
      <HelmetTitle />
      <Container>
        <CreateCampaignBreadcrumbsNoAuth
          platform={CampaignPlatformTypeEnum.SPOTIFY}
        />
        <SearchArtistSection
          {...artistSearch}
          createError=''
          isCreating={false}
          onCreateCampaign={onCreateCampaign}
        />
      </Container>
    </NoAuthPageLayout>
  )
}
